import Cookies from 'js-cookie'

const hostParts = window.location.host.split(".");
const domain = `.${hostParts.slice(-2).join(".")}`;
export function setJwtCookie(jwt) {
  const cookieOptions = {
    path: '/',
    expires: 1, // 1 day
    secure: true,
    sameSite: 'lax',
    domain
  };
  Cookies.set('fm-secure-link', jwt, cookieOptions);
}

export function deleteJwtCookie() {
  Cookies.remove('fm-secure-link', { path: '', domain })
}

// The token written on the last visit (setJwtCookie runs on every token
// change), usable as long as it is not about to expire. Null otherwise.
export function provisionalJwt() {
  const token = Cookies.get('fm-secure-link');
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.exp * 1000 - Date.now() > 60 * 1000 ? token : null;
  } catch {
    return null;
  }
}
